import _ from "lodash";
import {appConfig} from "../../firebase/client-app";

export {
    setDataInLocalStorage,
    getDataFromLocalStorage,
}

const setDataInLocalStorage = (key, data) => {
    localStorage.setItem(appConfig?.appKey + "." + key, JSON.stringify(data));
}

const getDataFromLocalStorage = (key) => {
    let data;
    const dataText = localStorage.getItem(appConfig?.appKey + "." + key);

    if (!_.isEmpty(dataText) && dataText !== 'undefined') {
        data = JSON.parse(dataText);
    }

    return data;
}
